theme.headerSticky = (function() {
  function ScrollSticky(e){
    const headerStickyTarget = document.querySelector('.header__sticky');

    if(headerStickyTarget){
      // Create a placeholder to prevent layout shift when header becomes fixed
      const placeholder = document.createElement('div');
      placeholder.style.display = 'none';
      headerStickyTarget.parentNode.insertBefore(placeholder, headerStickyTarget);

      // Calculate the offset: when the header top touches the viewport top
      function getStickyOffset() {
        if (headerStickyTarget.classList.contains('sticky')) {
          // While sticky, use placeholder position
          return placeholder.getBoundingClientRect().top + window.scrollY;
        }
        return headerStickyTarget.getBoundingClientRect().top + window.scrollY;
      }

      var stickyOffset = getStickyOffset();

      // Recalculate on resize (announcement bar height may change)
      window.addEventListener('resize', function() {
        if (!headerStickyTarget.classList.contains('sticky')) {
          stickyOffset = getStickyOffset();
        }
      });

      window.addEventListener('scroll', function(){
        if(window.scrollY >= stickyOffset){
          if(!headerStickyTarget.classList.contains('sticky')){
            placeholder.style.height = headerStickyTarget.offsetHeight + 'px';
            placeholder.style.display = 'block';
            headerStickyTarget.classList.add('sticky');
          }
        }else{
          if(headerStickyTarget.classList.contains('sticky')){
            headerStickyTarget.classList.remove('sticky');
            placeholder.style.display = 'none';
            // Recalculate offset after un-sticking
            stickyOffset = getStickyOffset();
          }
        }
      });
    }
  }
  return ScrollSticky;
})();
